import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  disableAllMenu,
  isActiveSosongFlowChartModal,
} from "modules/actions/statusMenu";
import { selectCategory } from "modules/actions/selectCategory";
import { setLevel1List } from "modules/actions/guideMap";
import { chatList } from "modules/actions/chat";
import { sendQuality, setRecheckQuality, setQuality, setResponse, } from "modules/actions/quality";
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';
import Pagination from "../Pagination";

import "./style.scss";
const SosongTermSearch = () => {
  const dispatch = useDispatch();
  const termSearchList = useSelector(
    (state) => state.termSearchList.termSearchList
  );
  const [limit, setLimit] = useState(16);
  const [page, setPage] = useState(1);
  const [currentSearchList, setCurrentSearchList] = useState(termSearchList);
  const [searchText, setSearchText] = useState("");
  const [notSearchText, setNotSearchText] = useState();
  const [result, setResult] = useState(true);
  
  const selectedMsgId = useSelector((state) => state.quality.selectedMsgId);
  
  const offset = (page - 1) * limit;
  const numPages = Math.ceil(currentSearchList.length / limit);
  // dispatch(termPageArr(numPages));
  const tempArr = Array.from({ length: numPages }, (v, i) => i + 1);
  const currentPageLine = Math.floor((page - 1) / 10) * 10;
  const pageListArr = tempArr.slice(currentPageLine, currentPageLine + 10);

  const closeServiceGuide = () => {
    dispatch(disableAllMenu());
    fallbackTabMove();
    
    const selector = `div[name="${selectedMsgId}"] ._additional_words_btn`;
    if (selectedMsgId === -1) {
      document.querySelector('._additional_words').focus();
    } else {
      document.querySelector(selector).focus();
    }
  };
  const moveOtherSite = () => {
    // window.location.href = `https://www.law.go.kr/lsTrmSc.do?menuId=13&subMenuId=65&query=${searchText}`;
    window.open(`https://www.law.go.kr/lsTrmSc.do?menuId=13&subMenuId=65&query=${searchText}`);
  };

  const handleQuerySearchTerm = (title, description) => {
    const paramSet = {
      inType: "term",
      inStr: description,
      inLabel: title,
      parameters: sessionStorage.getItem("address")
        ? {
            latitude_y: sessionStorage.getItem("latitude_y"),
            longitude_x: sessionStorage.getItem("longitude_x"),
            address: sessionStorage.getItem("address"),
            position_status: "Y",
          }
        : { latitude_y: "", longitude_x: "", position_status: "N" },
    };
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
    fallbackTabMove();
  };

  const onKeyPress = (e) => {
    if(!result) {
      setResult(true);
    }
    if(e.key === 'Enter') {
      handleSearchTerm(e);
    }
  }

  const handleSearchTerm = (e) => {
    if(!result) {
      setResult(true);
    }
    const filterTermSearchList = termSearchList.filter((obj) => {
      // console.log("obj",obj);
      const temp = searchText;
      return (
           // obj.title.match(new RegExp(temp)) ||
        // obj.description.match(new RegExp(temp))
        obj.title.match(new RegExp(temp))
      );
    });

    setPage(1);
    if (filterTermSearchList.length === 0) {
      setResult(false);
      console.log("page", page);
      setNotSearchText(`"${searchText}"에 대한 데이터를 찾을 수 없습니다.`);
    }

    setCurrentSearchList(filterTermSearchList);
    console.log("filterTermSearchList", filterTermSearchList);
  };

  const handleSearchText = (e) => {
    setSearchText(e.target.value);
    // if (!e.target.value) {
    //   setCurrentSearchList(termSearchList);
    // }
  };

  const onSosongFlowChart = (categoryName) => {
    dispatch(selectCategory(categoryName));
    dispatch(setLevel1List());
    dispatch(isActiveSosongFlowChartModal());
  };

  useEffect(() => {}, [page, currentSearchList]);
  useEffect(() => {
    disabledTabMoveButton(['searchButton','pageButton','ri-close-line term','btnTitle']); 
    disabledTabMoveInput(['inputTerm']);
  },[])


  return (
    <div className="additional_term_area">
      <button type='button' className="ri-close-line term" onClick={closeServiceGuide} aria-label='닫기'/>
      <div className="ad_name ad_name_01">
        <img
          src={`${process.env.PUBLIC_URL}/images/svg/additional/additionalTermSearch.svg`}
          alt=""
          style={{ width: "18px", marginRight: "3px" , position: 'relative', top: '3px'}}
        />
        연관 용어 찾기
      </div>
      <div className="searchBox">
        <input 
          type="text" 
          className="inputTerm" 
          aria-label="검색할 연관용어를 입력해주세요"
          title="검색할 연관용어를 입력해주세요" 
          onChange={handleSearchText}  
          onKeyPress={onKeyPress}
        />
        {/* <input type="text" className="inputTerm" onKeyPress={(e) => onKeyPress(e)}/> */}
        {/* <input type="text" className="inputTerm"/> */}
        <button
          type="button"
          className="searchButton"
          onClick={handleSearchTerm}
          style={{ cursor: "pointer" }}
        >
          검색
        </button>
      </div>
      <table className="tableSearch">
        <caption>연관 용어표 | 용어,뜻을(를) 나타낸 표</caption>
        <thead>
          <tr className="tableHead">
            {/* <th style={{ width: "120px", height: '25px' }}><button type="button" className="headTerm">용어</button></th> */}
            {/* <th><button type="button" className="headMean">뜻</button></th> */}
            <th style={{ width: "120px", height: '25px' }}>용어</th>
            <th>뜻</th>
          </tr>
        </thead>

        <tbody>
          {result &&
            currentSearchList.slice(offset, offset + limit).map((obj) => {
              return (
                <tr
                  className="tableTerm"
                  onClick={() => {
                    handleQuerySearchTerm(obj.title, obj.description);
                  }}
                >
                  <td className="title"><button className='btnTitle' type='button'>{obj.title}</button></td>
                  {/* <td className="description"><button className='btnDesc' type='button'>{obj.description}</button></td> */}
                  <td className="description">{obj.description}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {result && (
        <footer>
          <Pagination
            total={currentSearchList.length}
            limit={limit}
            page={page}
            setPage={setPage}
            pageListArr={pageListArr}
          />
        </footer>
      )}
      {!result && (
        <div className="notSearch">
          <p>{notSearchText}</p>
          <button type="button" onClick={moveOtherSite}>
            국가법령정보센터로 이동
          </button>
        </div>
      )}
    </div>
  );
};

export default SosongTermSearch;
